module.exports = __webpack_public_path__ + "img/facebook-square-brands.fc8432aa.svg";